import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from '../../Utils/reactIntlCompat';
import { useFormContext, Controller } from 'react-hook-form';
import { getForcedMessages } from '../../i18n';
import FetchAutoComplete from '../Inputs/FetchAutoComplete';
import { useFieldRequired } from './fieldRequiredContext';

const FormAutoComplete = function FormAutoComplete({
  intl,
  name,
  fetchCallback,
  defaultValue = null,
  required = false,
  width = '100%',
  error = null,
  allUpperCase = false,
  noCustomValue = false,
}) {
  const italianTerms = getForcedMessages('it');

  const { control, clearErrors } = useFormContext({
    defaultValues: {
      [name]: defaultValue ? italianTerms[defaultValue] || defaultValue : null,
    },
  });

  const { message = null } = error || {};
  const effectiveRequired = useFieldRequired(required);

  //from the field's name gets fields props like label, id, etc..
  const nameTranslation = Object.prototype.hasOwnProperty.call(
    intl.messages,
    name?.toUpperCase()
  )
    ? intl.messages[name.toUpperCase()]
    : null;

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={
        defaultValue ? italianTerms[defaultValue] || defaultValue : null
      }
      rules={{
        required: {
          value: effectiveRequired,
          message: intl.messages.MANDATORY_FIELD,
        },
      }}
      render={({ field: { onChange, value } }) => (
        <FetchAutoComplete
          fetchCallback={fetchCallback}
          id={`id-${name}`}
          selectedValue={value}
          allUpperCase={allUpperCase}
          onChangeSelectedValue={(e, data) => {
            clearErrors(name);
            onChange(data);
          }}
          label={nameTranslation}
          placeholder={`${intl.messages.INSERT} ${nameTranslation}`}
          error={error}
          helperText={message || ' '}
          required={effectiveRequired}
          width={width}
          noCustomValue={noCustomValue}
        />
      )}
    />
  );
};

FormAutoComplete.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  required: PropTypes.bool,
  width: PropTypes.string,
  intl: PropTypes.object.isRequired,
  error: PropTypes.object,
  fetchCallback: PropTypes.func.isRequired,
  allUpperCase: PropTypes.bool,
};

export default injectIntl(FormAutoComplete);
